import { all, call, put, takeEvery } from '@redux-saga/core/effects'
import * as actions from './actions'
import * as url from './url'
import { api } from '../api'

function* fetchADPConfigurations() {
    try {
        yield put(actions.configLoadingStart())
        const { data } = yield call(api, url.adpConfigURL, 'GET')
        if (data && data.feature_flag && data.feature_flag.length) {
            yield put(actions.fetchADPConfigurationsSuccess(data))
        } else {
            yield put(actions.fetchADPConfigurationsFailed())
            yield put(actions.configLoadingEnd())
        }
    } catch (error) {
        yield put(actions.fetchADPConfigurationsFailed())
        yield put(actions.configLoadingEnd())
    }
}

export default function* watchCommon() {
    yield all([
        takeEvery(actions.actionTypes.SAGA_FETCH_ADP_CONFIGURATIONS, fetchADPConfigurations),
    ])
}
